/**
 * Captures ad attribution params (GCLID / wbraid / gbraid / Reddit rdt_cid /
 * OpenAI oppref / UTM)
 * on landing and persists them in a first-party cookie for 90 days, so they can be
 * attached to conversions (`sign_up`, `booking_request`) and later used for Offline
 * Conversion Import. No PII is stored.
 */
export const ATTRIBUTION_PARAMS = [
  'gclid',
  'wbraid',
  'gbraid',
  // Reddit Ads click id. Reddit appends it when "Click ID" URL tracking is on
  // in the campaign — needed for the Conversions API / offline import later.
  'rdt_cid',
  // OpenAI-Ads-Klick-ID (Werbung in ChatGPT). Das Pixel-SDK speichert sie zwar
  // selbst im Cookie `__oppref`, aber nur für seine eigenen Ereignisse — in GA4
  // wäre Traffic aus ChatGPT-Anzeigen sonst nicht als solcher erkennbar.
  'oppref',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];
const KEYS = ATTRIBUTION_PARAMS;
const COOKIE = 'cw_attribution';
const DAYS = 90;

export function captureAttribution() {
  if (typeof window === 'undefined') {
    return;
  }
  const q = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach(k => {
    const v = q.get(k);
    if (v) {
      found[k] = v;
    }
  });
  if (!Object.keys(found).length) {
    return;
  }
  found.landing_page = window.location.pathname;
  found.ts = Date.now();
  const expires = new Date(Date.now() + DAYS * 864e5).toUTCString();
  document.cookie = `${COOKIE}=${encodeURIComponent(
    JSON.stringify(found)
  )};expires=${expires};path=/;SameSite=Lax`;
}

export function getAttribution() {
  if (typeof document === 'undefined') {
    return {};
  }
  const m = document.cookie.match(new RegExp('(^| )' + COOKIE + '=([^;]+)'));
  try {
    return m ? JSON.parse(decodeURIComponent(m[2])) : {};
  } catch (e) {
    return {};
  }
}

/**
 * Returns only the ad click identifiers from stored attribution, ready to be
 * spread into conversion events (`sign_up`, `booking_request`). Empty object if
 * the visitor did not arrive from an ad.
 */
export function adClickIds() {
  const a = getAttribution();
  const out = {};
  ['gclid', 'wbraid', 'gbraid', 'rdt_cid', 'oppref'].forEach(k => {
    if (a[k]) {
      out[k] = a[k];
    }
  });
  return out;
}
